import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthorService } from 'src/app/services/author.service';
import { FileService } from 'src/app/services/file.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ValidationService } from 'src/app/services/validation.service';
import { ViewAssetModalPage } from '../view-asset-modal/view-asset-modal.page';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-scene-background-modal',
  templateUrl: './scene-background-modal.page.html',
  styleUrls: ['./scene-background-modal.page.scss'],
})
export class SceneBackgroundModalPage implements OnInit {

  public numberOfBackgrounds: number;
  public noAssetsOfType: boolean;
  public loadFromAssetsPage: boolean = false;
  public addNewBackground: boolean = false;
  public addToAssetPage: boolean = false;
  public uploadedFileType: string;
  public fileUploaded: boolean = false;
  public displayAddButton: boolean = false;
  public searchNotFound: boolean = false;
  public buttonNotSelected = true;
  public assetSearchTerm: string;
  public assetsOnAssetManagementPage = [];
  public assetsOnAssetManagementPageCopy = [];
  public disableAddButton: boolean = false;
  public displayFileUploadError: boolean = false;
  public assetIDToCopy: number = -1;

  private isModalOpen: boolean = false;
  public compressVideo: boolean = false;

  constructor(
    public unfocusService: UnfocusElementService,
    private modalController: ModalController,
    public validationService: ValidationService,
    private authorService: AuthorService,
    private fileService: FileService,
    public assetManagementService: AssetManagementService,
    public assetTypeService: AssetTypeService,
    private deepCopyService: DeepCopyService,
    private alertController: AlertController,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.assetManagementService.getAssetsOnManagementPage().then(baseAssets => {
      this.numberOfBackgrounds = this.assetManagementService.assets.filter((asset: any) => asset.isBackground == "true").length;
      this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter((x: any) => x.isBackground == "true"));
      this.assetsOnAssetManagementPageCopy = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter((x: any) => x.isBackground == "true"));
    });
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  setUpFileType(event) {
    this.validationService.setFileType(event);
    if (this.validationService.uploadedFileType == "Image" || this.validationService.uploadedFileType == "Video") {
      this.displayFileUploadError = false;
      this.disableAddButton = false;
      if (event.target.files.length > 0) {
        this.fileUploaded = true;
      }
      else {
        this.fileUploaded = false;
      }
    }
    else {
      this.displayFileUploadError = true;
      this.fileUploaded = false;
      this.disableAddButton = true;
    }
  }

  async alertIncompatibleFile() {
    const alert = await this.alertController.create({
      header: 'Incompatible file uploaded.',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  resetModal(event) {
    this.unfocusService.unfocus(event);
    this.displayAddButton = false;
    this.buttonNotSelected = true;
    this.addNewBackground = false;
    this.loadFromAssetsPage = false;
    this.fileUploaded = false;
  }

  checkboxSelected(buttonClicked, event) {
    this.unfocusService.unfocus(event);
    this.displayAddButton = true;
    this.buttonNotSelected = false;
    this.validationService.uploadedFileType = "";
    if (buttonClicked == "assetManagement") {
      this.disableAddButton = false;
      this.loadFromAssetsPage = true;
      this.addNewBackground = false;
      if (this.numberOfBackgrounds == 0) {
        this.noAssetsOfType = true;
        this.displayAddButton = false;
      }
      else {
        this.noAssetsOfType = false;
      }
    }
    else {
      this.addNewBackground = true;
      this.loadFromAssetsPage = false;
      this.noAssetsOfType = false;
      this.disableAddButton = true;
    }
  }

  async launchAsset(asset) {
    // Because of a circular dependency - this section is in the modalService too

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": asset
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  searchByAsset(event) {
    let name: string = event.target.value;

    this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    var assets = this.assetsOnAssetManagementPage.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length == 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPage = assets;
    }
  }

  addBackgroundToScene(event, files) {
    this.unfocusService.unfocus(event);

    if (this.loadFromAssetsPage) {
      //console.log(this.assetIDToCopy);
      if (this.assetIDToCopy == -1 || this.assetIDToCopy == undefined) {
        this.validationService.alertForNoSceneBackgroundSelected();
      }
      else {
        let asset = this.assetsOnAssetManagementPage.find(a => a.baseAssetId == this.assetIDToCopy);
        this.assetIDToCopy = -1;

        this.closeModalAndPassBackgroundSrc(asset);
      }
    } else {
      this.addBackgroundFromFile(files);
    }
  }

  addBackgroundFromFile(files) {
    var file = files[0];
    console.log(file);
    var sceneId: number = this.authorService.currentScene.sceneId

    if (this.validationService.uploadedFileType == "Image") {
      if (this.authorService.currentScene.sceneBackgroundSrc != null) {
        this.authorService.skyId = "#pano-blank";
        this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d').then(async (srcResult) => {
          this.closeModalForNewBackground(srcResult, "Image", false);
        });
      }
    }
    else if (this.validationService.uploadedFileType == "Video") {
      if (this.authorService.currentScene.sceneBackgroundSrc != null) {
        this.authorService.skyId = '#pano-blank';
        if (this.compressVideo) {
          this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', true).then((srcResult) => {
            let scene = this.authorService.currentScene;
            scene.uploadStatus = 'uploading';
            this.fileService.addVideoToCheckUploadStatus('scene', sceneId, scene, srcResult);
            this.fileService.initialiseVideoUploadStatusCheck();
            this.closeModalForNewBackground(this.fileService.videoAssetUploadingPlaceholder, "Video", true);
          });
        }
        else {
          this.fileService.replaceSceneBackgroundFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d').then(async (srcResult) => {
            this.authorService.currentScene.uploadStatus = 'complete';
            this.closeModalForNewBackground(srcResult, "Video", false);
          });
        }
      }
    }
    else {
      this.alertIncompatibleFile();
    }
  }

  setMediaAsset(src, type): MediaAsset {
    var mediaAsset = new MediaAsset();
    mediaAsset.src = src;
    mediaAsset.assetTypeId = type;
    return mediaAsset;
  }

  closeModalForNewBackground(src, assetType, videoCompresing) {
    var dataMedia = { "backgroundSrc": src, "assetType": assetType, "compressing": videoCompresing };
    this.modalController.dismiss(dataMedia);
  }

  // modal.onDidDismiss(). found in author.service
  closeModalAndPassBackgroundSrc(asset: MediaAsset) {
    var dataMedia = { "backgroundSrc": asset.src, "assetType": this.assetTypeService.getType(asset.assetTypeId), "compressing": false };
    this.modalController.dismiss(dataMedia);
  }

}
